import { useSearchParams } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

import "./Profile.css";
import "./Sidebar.css";
import "./Dashboard.css";
import "./utilities.css";
import "./Responsive.css";

import PersonalInfo from "./PersonalInfo";
import Address from "./Address";
import Cards from "./Cards";
import Orders from "./Orders";
import Wishlist from "./Wishlist";
import Settings from "./Settings";

const VALID_TABS = ["profile", "orders", "wishlist", "address", "cards", "settings"];

function Profile() {
  const [searchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : "profile";

  return (
    <div className="profile-page">
      <div className="profile-container">
        <main className="profile-content">
          {activeTab === "profile" && <PersonalInfo />}
          {activeTab === "address" && <Address />}
          {activeTab === "cards" && <Cards />}
          {activeTab === "orders" && <Orders />}
          {activeTab === "wishlist" && <Wishlist />}
          {activeTab === "settings" && <Settings />}
        </main>
      </div>
    </div>
  );
}

export default Profile;